import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import SkeletonLoader from '../../components/SkeletonLoader'; 

function PdfViewer() {
  const location = useLocation();
  const [fileUrl, setFileUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { file } = location.state || {}; // Access the file from state passed via `navigate`
    if (file) {
      setFileUrl(file); // Set the PDF URL
    }
  }, [location]);

  const handleIframeLoad = () => {
    setLoading(false); // Set loading to false when the iframe has finished loading
  };

  return (
    <div>
      {loading && (
        <div>
          <SkeletonLoader count={1} height={800} />
        </div>
      )}
      {fileUrl && (
        <iframe
          src={fileUrl}
          width="100%"
          height="800px"
          title="PDF Viewer"
          frameBorder="0"
          onLoad={handleIframeLoad}
          style={{ display: loading ? 'none' : 'block' }} // Hide iframe while loading
        />
      )}
      {!fileUrl && !loading && <p>PDF file not available.</p>}
    </div>
  );
}

export default PdfViewer;
